export const MODAL_SURFACE_RADIUS_CLASS = "rounded-3xl";
